import { createContext, useReducer, useEffect } from "react";

export const AuthContext = createContext();

export const authReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return { user: action.payload, render: state.render };
    case "LOGOUT":
      return { user: null, render: state.render };
    case "RENDER":
      return { user: state.user, render: action.payload };
    default:
      return state;
  }
};

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, {
    user: null, render: false
  });

  useEffect(() => {

    const user = JSON.parse(localStorage.getItem("user"));

    dispatch({ type: "RENDER", payload: true })

    if (user) {
      dispatch({ type: "LOGIN", payload: user });
    }

  }, []);

  return (
    <AuthContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};
